import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import { useMemo as u, Children as g, cloneElement as x } from "react";
import { S as f } from "./status-message-BMoS1d1Y.mjs";
import { L as h } from "./layout-box-DFBM-kSI.mjs";
import { l as y } from "./lodash-5ofSKtz3.mjs";
import { g as S } from "./get-aria-describedby-G1wcWKF2.mjs";
import { c as M } from "./capitalize-iyaz5rT3.mjs";
const I = (c) => {
  const { ariaLabel: n, ariaDescribedby: l, children: m, type: r, status: e, errorMessage: s, warningMessage: o } = c, p = M(r), t = u(() => y.uniqueId("selectable-box-group-status-msg-"), []), i = e === "error" && s || e === "warning" && o, d = S(i ? t : "", l);
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      "aria-describedby": d,
      "aria-invalid": e === "error",
      "aria-label": n,
      className: `fab-${p}Group SelectableBoxWrapper`,
      "data-fabric-component": "SelectableBoxGroup",
      role: r === "radio" ? "radiogroup" : void 0,
      children: [
        g.map(m, (b) => x(b, {
          type: r
        })),
        i && /* @__PURE__ */ a.jsx(h, { marginTop: 1, children: /* @__PURE__ */ a.jsx(
          f,
          {
            id: t,
            message: e === "error" ? s : o,
            showIcon: !0,
            status: e,
            width: 100
          }
        ) })
      ]
    }
  );
};
export {
  I as S
};
//# sourceMappingURL=selectable-box-group-CQY3NPT0.mjs.map
